module.exports = __webpack_public_path__ + "img/section3Tab2Icon2.e4829943.png";